import React, { useMemo } from 'react';
import styles from './index.module.less';
import Image from 'next/image';
import classNames from 'classnames';
import { SectionData } from '@/types/home';
import { ChevronRight } from 'lucide-react';
import { useRouter } from 'next/router';

const RelatedToolsContent = ({ data }: { data?: SectionData }) => {
  const router = useRouter();

  const getContent = useMemo(() => {
    return data ? (
      <div className={styles.content}>
        {data?.title && <h2 className={styles.title}>{data?.title}</h2>}

        {data?.desc && <p className={styles.desc}>{data?.desc}</p>}

        {data?.cards?.length > 0 && (
          <div className={classNames([styles.contentList])}>
            {data.cards?.map((item, index) => (
              <div className={styles.contentItem} key={index}>
                <div
                  className={classNames(styles.contentItemTitle)}
                  onClick={() => {
                    if (item?.link?.startsWith('http')) {
                      item?.link && window.open(item?.link, '_blank');
                    } else {
                      item?.link && router.push(item?.link);
                    }
                  }}
                >
                  <Image src={item.imgPath} alt={''} width={24} height={24} />
                  <h3 className={styles.subTitle}>{item.title}</h3>
                </div>
                <ChevronRight className={styles.arrowIcon} style={{ width: '24px', height: '24px' }} />
              </div>
            ))}
          </div>
        )}
      </div>
    ) : null;
  }, [data]);

  return getContent;
};

export default RelatedToolsContent;
